if (!customElements.get('adev-product-upsell')) {
    customElements.define('adev-product-upsell', class adevProductUpsell extends HTMLElement {
        constructor() {
            super();
        }
        
        initSlider(){
            const carouselEl = this.querySelector('[data-adev-product-upsell="carousel"]');

            this.slider = new Flickity(carouselEl, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true,
                adaptiveHeight: false,
                on: {
                    ready: function() {
                        this.slider.classList.add("flickity-resize");
                    }
                }
            });

            this.querySelectorAll('[data-adev-product-upsell-atc]').forEach(button => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    button.classList.add('loading');

                    const variantId = button.getAttribute('data-adev-product-upsell-atc');
                    this.addToCart(variantId, button);
                });
            });
        }

        addToCart(variantId, button) {
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 1);

            formData.append('sections', 'cart-count,cart-drawer');
            formData.append('sections_url', window.location.pathname);
            
            fetch(adev_theme.routes.cartAddUrl, {
                method: 'POST',
                body: formData,
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {

                this.refreshCart(data);
                button.classList.remove('loading');
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                button.classList.remove('loading');
            });
        }
        
        refreshCart(cart){
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.renderContents(cart);

                if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            }
        }

        destroySlider(){
            if (this.slider) {
                this.slider.destroy();
            }
        }

        connectedCallback() {
            this.initSlider();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}